import cx from 'classnames'
import React from 'react'
import { resolveInitialSearchQuery } from '../../reducers/user.js'
import type { Campaign } from '../../types/campaign.js'
import { MaxWidthNameColumn } from '../../util/table.js'
import { TargetingTypeSmall } from '../badge/TargetingTypeSmall.js'
import { PreservingLink } from '../ui/PreservingLink.js'
import { NameText } from './NameText.js'

interface CampaignNameProps {
    campaign: Pick<Campaign, 'campaign_id' | 'name'> & Partial<Campaign>
    screenshotMode?: boolean
    showBadge?: boolean
    fill?: boolean
}

export const CampaignName = ({
    campaign,
    screenshotMode,
    showBadge = true,
    fill = false,
}: CampaignNameProps) => {
    if (!campaign) {
        return null
    }
    const searchQuery = resolveInitialSearchQuery()
    let to = `/campaigns/${campaign.campaign_id}`

    if (searchQuery) {
        to = to + `?${searchQuery}`
    }

    return (
        <PreservingLink
            className={cx('relative flex min-w-0 items-center pr-4', fill && 'w-full', {
                blur: screenshotMode,
            })}
            to={to}
            style={{ maxWidth: fill ? undefined : MaxWidthNameColumn }}
        >
            {showBadge && (
                <TargetingTypeSmall
                    className="mr-2"
                    targeting_type={campaign?.targeting_type}
                    state={campaign?.state}
                />
            )}
            <NameText screenshotMode={screenshotMode} className="min-w-0 w-full pl-2.5">
                {campaign.name}
            </NameText>
        </PreservingLink>
    )
}
